import { getSettingValueWithoutAssignment } from "@faire/help-center-utils/settings/getSetting";
import { RECORD_SESSION_HOTJAR } from "@faire/web-api--source/indigofair/settings/RECORD_SESSION_HOTJAR";

export function getSettingRecordSessionInHotjar(): boolean {
  return getSettingValueWithoutAssignment(RECORD_SESSION_HOTJAR, false);
}
